"use strict";
exports.__esModule = true;
exports.KeyFigurePicture = void 0;
var KeyFigurePicture;
(function (KeyFigurePicture) {
    KeyFigurePicture[KeyFigurePicture["ARROWLEAF"] = 1] = "ARROWLEAF";
    KeyFigurePicture[KeyFigurePicture["ARROWUSER"] = 2] = "ARROWUSER";
})(KeyFigurePicture = exports.KeyFigurePicture || (exports.KeyFigurePicture = {}));
//# sourceMappingURL=key-figure-slice.js.map